import { useMemo } from 'react';

import { getFilterOptions } from '../../../helpers/filter';

import { SELECT_OPTIONS, LIVESTOCK_LOSS_REASONS } from '../../../constants/common';
import { BLANK_FILTER_TEXT } from '../../../constants/livestock';

export const useFilterOptions = ({ animals }) => {
  return useMemo(() => {
    if (!Array.isArray(animals) || animals.length === 0) {
      return {
        breeds: [],
        connectionStatuses: [],
        farms: [],
        locations: [],
        sex: []
      };
    }

    const locationsSet = new Set();

    animals.forEach(animal => {
      const firstGeofence = animal.assigned_geofences?.[0];
      locationsSet.add(firstGeofence || BLANK_FILTER_TEXT);
    });

    const locationOptions = Array.from(locationsSet).map(location => ({
      text: location,
      value: location
    }));

    return {
      breedingStatuses: getFilterOptions(animals, 'breeding_status'),
      breeds: getFilterOptions(animals, 'breed', 'display_name'),
      connectionStatuses: getFilterOptions(animals, 'tag', 'status'),
      farms: getFilterOptions(animals, 'farm', 'name'),
      locations: locationOptions,
      polledHorned: getFilterOptions(animals, 'polled_horned').filter(option =>
        SELECT_OPTIONS.POLLED_HORNED.map(option => option.value).includes(option.value)
      ),
      sex: getFilterOptions(animals, 'sex'),
      types: getFilterOptions(animals, 'stock_type'),
      lossReason: LIVESTOCK_LOSS_REASONS.map(reason => ({ value: reason, text: reason })),
    };
  }, [animals]);
};
